import React from "react";
import { IconMailLight, IconMax } from "../../assets/icons/Icon";
import Logo from "./logo-white.png";
import { scrollToApplication } from "../../hooks/scrollTo";
import { useHomeNavigation } from "../../hooks/useHomeNavigation";
import {
  FooterContainer,
  LogoContainer,
  LogoLink,
  CompanyInfoBlock,
  CompanyInfoBlockMobile,
  NavLinks,
  NavLink,
  ContactUs,
  ContactLine,
  ContactUsLink,
} from "./Footer.styles";

const Footer: React.FC = () => {
  const navigateToHome = useHomeNavigation();

  return (
    <FooterContainer>
      <LogoContainer>
        <LogoLink to="/">
          <img src={Logo} alt="ИРТ" />
        </LogoLink>
        <CompanyInfoBlock>
          <p>ИНН/КПП:7203368755/720301001</p>
          <p>ОГРН: 1167232050050</p>
          <p>Россия, г. Тюмень, 625001</p>
        </CompanyInfoBlock>
      </LogoContainer>
      <NavLinks>
        <NavLink onClick={() => navigateToHome("top")}>Главная</NavLink>
        <NavLink onClick={() => navigateToHome("about")}>О нас</NavLink>
        <NavLink onClick={() => navigateToHome("products")}>Продукты</NavLink>
        <NavLink onClick={() => navigateToHome("contacts")}>Контакты</NavLink>
      </NavLinks>
      <ContactUs>
        <ContactLine href="mailto:info@i-d-tech.com">
          <IconMailLight />
          <p>info@i-d-tech.com</p>
        </ContactLine>
        <ContactLine href="https://max.ru/id7203368755_bot">
          <IconMax />
          <p>max.ru/id7203368755_bot</p>
        </ContactLine>
        <ContactUsLink onClick={scrollToApplication}>
          <p>Связаться с нами</p>
          <i className="pi pi-arrow-up-right" />
        </ContactUsLink>
      </ContactUs>
      <CompanyInfoBlockMobile>
        <p>ИНН/КПП:7203368755/720301001</p>
        <p>ОГРН: 1167232050050</p>
        <p>Россия, г. Тюмень, 625001</p>
      </CompanyInfoBlockMobile>
    </FooterContainer>
  );
};

export default Footer;
